module.exports = __webpack_public_path__ + "img/recipe.1c45f04e.jpg";